export default __webpack_public_path__ + "bb2f5cd8b296318788e8f2ce1516a9fe.png";